import { ShieldCheck } from "lucide-react";
import { useApp } from "@/hooks/useApp";

/**
 * Selo "Oficial NickRobotic" — exibido apenas em produtos do supplier house (slug=oficial).
 * Usar quando `isOfficial === true` (vindo de products.supplier_id == house_supplier_id()).
 */
export default function OficialBadge({
  isOfficial,
  size = "sm",
  className = "",
}: {
  isOfficial?: boolean | null;
  size?: "xs" | "sm" | "md";
  className?: string;
}) {
  const { lang } = useApp();
  if (!isOfficial) return null;
  const label = lang === "en" ? "Official" : "Oficial";
  const sz =
    size === "md"
      ? "text-xs px-2.5 py-1"
      : size === "xs"
      ? "text-[9px] px-1.5 py-0.5"
      : "text-[10px] px-2 py-0.5";
  return (
    <span
      data-testid="oficial-badge"
      className={`inline-flex items-center gap-1 rounded-full font-semibold uppercase tracking-wide bg-primary text-primary-foreground shadow-sm ${sz} ${className}`}
      title={lang === "en" ? "Sold by NickRobotic Official" : "Vendido por NickRobotic Oficial"}
    >
      <ShieldCheck className="w-3 h-3" aria-hidden="true" />
      {label}
    </span>
  );
}
